export default __webpack_public_path__ + "static/media/arrow_forward_yono@2x.437c5b0e.png";